import ProficiencyGroupsMobile from './ProficiencyGroupsMobile';

export default ProficiencyGroupsMobile;
export { ProficiencyGroupsMobile };
